export default {
  ...window.CONFIG,
  version: import.meta.env.PACKAGE_VERSION,
};

// These values are referenced outside of the redux store. Only use these when a selector would not work.
export const {
  isProduction: IS_PRODUCTION,
  apiBaseUrl: API_BASE_URL,
  googleAnalyticsId: GOOGLE_ANALYTICS_ID,
  defaultStudioUrlPat: DEFAULT_STUDIO_URL_PAT,
  defaultStudioUrl: DEFAULT_STUDIO_URL,
  defaultGuestUrlPat: DEFAULT_GUEST_URL_PAT,
  defaultGuestUrl: DEFAULT_GUEST_URL,
} = window.CONFIG;
